<template>
  <v-container
    class="pa-0"
    fluid>
    <v-row class="pl-2 pr-2">
      <v-col
        cols="12"
        md="6"
        offset-md="3"
      >
        <template
          v-if="permissionSlips.length !== 0"
        >
          <v-card-text class="pt-5">I give permission for my child <span class="font-weight-bold">{{ pupilFullName }}</span> to participate in:</v-card-text>
          <v-card
            class="mb-4">
            <v-card-title>select a permission slip</v-card-title>
            <v-card-text class="pb-0 font-weight-bold">
              <v-list
                density="compact"
                lines="2"
              >
                <v-list-item
                  v-for="slip in permissionSlips"
                  :key="slip.id"
                  @click="selectedPermissionSlip = slip.id; getSlipInfo()"
                  :class="{ 'active-item': selectedPermissionSlip === slip.id }"
                >
                  <v-list-item-title>{{ slip.name }}</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-card-text>
          </v-card>
          <v-card>
            <v-card-text v-if="this.permissionSlipSubmitted === true">
              <v-alert
                :value="true"
                type="success">
                <span v-if="signedBy">
                  You have already signed this permission slip. Thank you.
                </span>
                <span v-else>
                  Another caregiver has signed this permission slip. Thank you.
                </span>
              </v-alert>

              <template v-if="slipSubmittedInfo && slipSubmittedInfo.alreadySigned">
                <v-divider class="my-3" />

                <div class="text-subtitle-1 font-weight-bold mb-2">Submission Details</div>
                <v-simple-table dense>
                  <tbody>
                    <tr>
                      <td
                        class="font-weight-medium"
                        style="width: 140px;">Signed by</td>
                      <td>{{ slipSubmittedInfo.pupilInfo.caregiver }}</td>
                    </tr>
                    <tr>
                      <td class="font-weight-medium">Signed at</td>
                      <td>{{ slipSubmittedInfo.pupilInfo.signedAt }}</td>
                    </tr>
                    <tr v-if="slipSubmittedInfo.pupilInfo.additionalInfo">
                      <td class="font-weight-medium">Additional info</td>
                      <td>{{ slipSubmittedInfo.pupilInfo.additionalInfo }}</td>
                    </tr>
                    <tr v-if="slipSubmittedInfo.pupilInfo.permission">
                      <td class="font-weight-medium">Permission</td>
                      <td>{{ slipSubmittedInfo.pupilInfo.permission }}</td>
                    </tr>
                  </tbody>
                </v-simple-table>

                <template v-if="slipSubmittedInfo.signedAnswers && slipSubmittedInfo.signedAnswers.length">
                  <div class="text-subtitle-1 font-weight-bold mt-4 mb-2">Answers</div>
                  <v-simple-table dense>
                    <tbody>
                      <tr
                        v-for="answer in slipSubmittedInfo.signedAnswers"
                        :key="answer.fieldId"
                      >
                        <td
                          class="font-weight-medium"
                          style="width: 220px;">{{ answer.fieldLabel }}</td>
                        <td>{{ answer.answer }}</td>
                      </tr>
                    </tbody>
                  </v-simple-table>
                </template>
              </template>
            </v-card-text>
          </v-card>
          <v-spacer />
          <v-card>
            <v-card-text
              v-if="this.permissionSlipInfo !== ''"
              class="pt-0">
              <v-card-text>
                <h2>{{ permissionSlips.find(x => x.id == selectedPermissionSlip).name }}</h2>
              </v-card-text>
              <v-card-text class="pb-0 font-weight-bold">{{ permissionSlips.find(x => x.id == selectedPermissionSlip).date }}</v-card-text>
              <v-card-text style="overflow-wrap: break-word;">
                <div v-html="permissionSlipInfo" />
                <v-card-actions>
                  <v-btn
                    v-if="canDelete"
                    color="red darken-1 white--text"
                    @click="confirmDeleteDialog = true"
                  >
                    Delete
                  </v-btn>
                </v-card-actions>
              </v-card-text>
          </v-card-text></v-card>

          <template v-if="checkExpiration">
            <v-card
              v-if="Dbasename !== 'RCS'"
              class="pb-0">
              <v-card-text>
                <h2>Your Details</h2>
              </v-card-text>
              <v-card-text>
                <v-text-field

                  class="pt-0 pb-0"
                  label="Name"
                  :value="parentName"
                  readonly
                />
                <v-text-field

                  class="pt-0 pb-0"
                  label="Email"
                  :value="caregiver.email"
                  readonly
                />
                <v-text-field

                  class="pt-0 pb-0"
                  v-if="(caregiver.address !== '' || caregiver.address2 !== '') && (caregiver.address !== null || caregiver.address2 !== null)"
                  label="Address"
                  :value="caregiver.address + ', ' + caregiver.address2"
                  readonly
                />
                <v-text-field

                  class="pt-0 pb-0"
                  v-if="caregiver.phone !== '' && caregiver.phone !== null"
                  label="Phone"
                  :value="caregiver.phone"
                  readonly
                />
                <v-text-field

                  class="pt-0 pb-0"
                  v-if="caregiver.mobile !== '' && caregiver.mobile !== null"
                  label="Mobile"
                  :value="caregiver.mobile"
                  readonly
                />
                <v-text-field

                  class="pt-0 pb-0"
                  v-if="caregiver.workphone !== '' && caregiver.workphone !== null"
                  label="Work Phone"
                  :value="caregiver.workphone"
                  readonly
                />
              </v-card-text>
            </v-card>

            <v-card-text>
              <v-row
                v-for="(field, ind) in extraFields"
                :key="ind">
                <v-col cols="12">
                  <component
                    :is="field.fieldType"
                    :name="field.modelName"
                    :options="field.fieldOptions"
                    :extra-fields-value.sync="extraFieldsValue[field.modelName]"
                    :field-label="field.fieldStatus === 'Compulsory' ? ' * ' + field.fieldLabel : field.fieldLabel"
                  />
                </v-col>
              </v-row>
            </v-card-text>

            <v-card-text
              class="pb-0">
              <p style="color:grey;">Any additional information?</p>
              <v-textarea
                outline
                class="pt-0 pb-0"
                no-resize
                v-model="additionalInfo"
              />
            </v-card-text>

            <v-card-text
              v-if="withYesOrNo"
              class="pt-0">
              <v-select
                :items="permissionSelection"
                dense
                outlined
                label="Permission"
                v-model="permissionSelect"
              />
            </v-card-text>

            <v-card-text
              class="pt-0">
              Signature of parent/legal guardian*
              <v-btn
                class="text-right"
                text
                @click.native="clear()"
              >Clear</v-btn>
              <VueSignaturePad
                id="signature"
                width="100%"
                height="250px"
                ref="signaturePad"
              />
              <div>
                <v-btn
                  @click="save()"
                  block
                  color="primary"
                >Submit</v-btn>
              </div>
            </v-card-text>
          </template>
        </template>
        <v-alert
          :value="true"
          type="info"
          class="white--text"
          transition="scale-transition"
          v-else>
          No permission slips are available right now.
        </v-alert>
      </v-col>
    </v-row>

    <v-dialog
      v-model="confirmDeleteDialog"
      max-width="500px">
      <v-card>
        <v-card-title>Confirm Deletion</v-card-title>
        <v-card-text>Are you sure you want to delete this permission slip?</v-card-text>
        <v-card-actions>
          <v-btn
            color="red darken-1 white--text"
            @click="confirmDeleteDialog = false">No</v-btn>
          <v-btn
            color="green darken-1 white--text"
            @click="confirmDelete">Yes</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      persistent
      v-model="responseDialog"
      max-width="350"
    >
      <v-card>
        <v-card-text class="text-center pb-0 pt-3">
          <v-icon
            size="50"
            :color="responseDialogIconColor"
          >{{ responseDialogIcon }}</v-icon>
        </v-card-text>
        <v-card-text class="text-center subheading">{{ responseDialogMessage }}</v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            :color="responseDialogIconColor"
            text
            @click.native="closeResponseDialog()"
          >Ok</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

  </v-container>
</template>

<script>
import VueSignaturePad from 'vue-signature-pad'
import { mapState } from 'vuex'

export default {
  data: () => ({
    // options: {
    //   backgroundColor: 'rgb(255,255,255)'
    // },
    permissionSlips: [],
    permissionSlipInfo: '',
    permissionSlipSubmitted: false,
    selectedPermissionSlip: '',
    additionalInfo: '',
    caregiver: {},
    caregiverInfoArray: {},
    caregiverToUse: '',

    responseDialog: false,
    responseDialogIcon: 'warning',
    responseDialogIconColor: 'green',
    responseDialogMessage: '',

    permissionSelection: ['Yes', 'No'],
    permissionSelect: '',
    withYesOrNo: false,
    signedBy: true,
    extraFields: [],
    publishedTo: '',
    expired: false,
    confirmDeleteDialog: false,
    slipSubmittedInfo: []
  }),

  components: {
    VueSignaturePad,
    Comment: () => import('@/components/FieldTypes/Comment.vue'),
    Textline: () => import('@/components/FieldTypes/Textline.vue'),
    Dropdown: () => import('@/components/FieldTypes/Dropdown.vue'),
    Radio: () => import('@/components/FieldTypes/Radio.vue'),
    Checkbox: () => import('@/components/FieldTypes/Checkbox.vue')
  },

  computed: {
    ...mapState(['parentName', 'userId', 'trueUser', 'pupilId', 'Dbasename']),
    pupilFullName: function () {
      return this.$store.getters.pupilFullName
    },
    checkExpiration () {
      let expired = false
      if (this.publishedTo !== '') {
        const today = new Date()
        today.setHours(0, 0, 0, 0)
        const publishedTo = new Date(this.publishedTo)
        publishedTo.setHours(0, 0, 0, 0)

        if (today > publishedTo) {
          expired = true
          return false
        } else {
          return (
            this.permissionSlipSubmitted === false &&
            expired === false
          )
        }
      }
      return expired
    },
    canDelete () {
      if (!this.publishedTo || !this.permissionSlipSubmitted) {
        return false
      }
      const today = new Date()
      today.setHours(0, 0, 0, 0)
      const publishedTo = new Date(this.publishedTo)
      publishedTo.setHours(0, 0, 0, 0)
      return publishedTo >= today
    }
  },
  mounted: function () {
    this.$store.dispatch('logReadItems')
  },
  methods: {
    convertURLsToHref: function (stringToConvert) {
      return stringToConvert.replace(/(http)(s)?(:\/\/)(([a-zA-Z])([-\w]+\.)+([^\s.]+[^\s]*)+[^,.\s])/g, "<a href='http$2://$4' class='v-btn theme--light' style='text-decoration: none;' target='_blank' title='$&'>Open Link</a><br>")
    },
    dataURItoBlob (dataURI) {
      // convert base64 to raw binary data held in a string
      // doesn't handle URLEncoded DataURIs - see SO answer #6850276 for code that does this
      var byteString = atob(dataURI.split(',')[1])

      // separate out the mime component
      var mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0]

      // write the bytes of the string to an ArrayBuffer
      var ab = new ArrayBuffer(byteString.length)

      // create a view into the buffer
      var ia = new Uint8Array(ab)

      // set the bytes of the buffer to the correct values
      for (var i = 0; i < byteString.length; i++) {
        ia[i] = byteString.charCodeAt(i)
      }

      // write the ArrayBuffer to a blob, and you're done
      var blob = new Blob([ab], { type: mimeString })
      return blob
    },

    clear () {
      this.$refs.signaturePad.clearSignature()
    },

    undo () {
      this.$refs.signaturePad.undoSignature()
    },

    save () {
      const { isEmpty, data } = this.$refs.signaturePad.saveSignature()
      const extraFields = Object.values(this.extraFields)

      for (const field of extraFields) {
        if (field.fieldStatus === 'Compulsory' && this.extraFieldsValue[field.modelName].value === '') {
          this.responseDialogIcon = 'warning'
          this.responseDialogIconColor = 'red'
          this.responseDialogMessage = 'Please fill out all compulsory fields.'
          this.responseDialog = true
          return
        }
      }

      if (this.withYesOrNo === true && this.permissionSelect === '') {
        this.responseDialogIcon = 'warning'
        this.responseDialogIconColor = 'red'
        this.responseDialogMessage = 'Please select Yes or No.'
        this.responseDialog = true
        return
      }

      if (!isEmpty) {
        const formData = new FormData()
        formData.append('caregiver_id', this.userId)
        formData.append('additional_info', this.additionalInfo)
        formData.append('file', this.dataURItoBlob(data))
        formData.append('permission_select', this.permissionSelect)
        formData.append('extraFormValue', JSON.stringify(this.extraFieldsValue))

        this.$http.post('caregiversV2/' + this.Dbasename + '/' + this.trueUser + '/pupilsV2/' + this.pupilId + '/permissionslipsV2/' + this.selectedPermissionSlip + '/savePermissionV2', formData)
          .then(resp => {
            if (resp.data.success) {
              this.successDialog()
            } else {
              this.errorDialog('An error has occurred, please try again.')
              window.location.reload(true)
            }
          })
      } else {
        this.errorDialog('Signature cannot be empty. Please sign before submitting.')
      }
    },

    getSlipInfo () {
      this.$http.get('caregiversV2/' + this.Dbasename + '/' + this.trueUser + '/permissionslipsV2/' + this.selectedPermissionSlip + '/pupilsV2/' + this.pupilId + '/permissionInfoV5')
        .then(resp => {
          this.permissionSlipInfo = resp.data.info
          this.permissionSlipSubmitted = resp.data.submitted
          this.withYesOrNo = resp.data.withYesOrNo
          this.signedBy = resp.data.signedBy
          this.extraFields = resp.data.extraFields
          this.extraFieldsValue = resp.data.extraFieldsValue
          this.publishedTo = resp.data.publishedTo
          this.slipSubmittedInfo = resp.data.slipSubmittedInfo

          if (this.permissionSlipSubmitted !== true) {
            setTimeout(() => {
              this.$refs.signaturePad.resizeCanvas()
            }, 250)
          }
        })
    },

    errorDialog (errorMsg) {
      this.responseDialogIcon = 'error'
      this.responseDialogIconColor = 'red'
      this.responseDialogMessage = errorMsg
      this.responseDialog = true
    },

    successDialog () {
      this.responseDialogIcon = 'check_circle'
      this.responseDialogIconColor = 'green'
      this.responseDialogMessage = 'Permission slip submitted successfully.'
      this.responseDialog = true
    },

    closeResponseDialog () {
      this.responseDialog = false
      if (this.responseDialogIcon === 'check_circle') {
        this.$router.replace('/home')
        this.$store.commit('toggle_dialog', false)
      }
    },
    confirmDelete () {
      this.$http.delete('caregiversV2/' + this.Dbasename + '/' + this.trueUser + '/permissionslipsV2' + '/' + this.pupilId + '/' + this.selectedPermissionSlip + '/deletePermissionV2')
        .then(resp => {
          if (resp.data.success) {
            window.location.reload()
          } else {
            this.errorDialog('An error has occurred, please try again.')
          }
        })
      this.confirmDeleteDialog = false
    }
  },

  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.$store.commit('toggle_dialog', true)

      // Get permission slips
      vm.$http.get('/pupilsV2/' + vm.$store.state.Dbasename + '/' + vm.$store.state.pupilId + '/permissionslipsV2')
        .then(resp => {
          vm.permissionSlips = resp.data
          if (vm.permissionSlips.length > 0) {
            let firstItem = vm.permissionSlips[0]
            vm.selectedPermissionSlip = firstItem.id
            vm.getSlipInfo()
          }

          // Get caregiver info
          vm.$http.get('/caregiversV2/' + vm.$store.state.Dbasename + '/' + vm.$store.state.userId + '/pupilsV2/' + vm.$store.state.pupilId + '/caregiverInfoArrayV2')
            .then(resp => {
              vm.caregiver = resp.data

              setTimeout(() => {
                vm.$store.commit('loading', false)
              }, 1000)
            })
        })
    })
  }
}
</script>

<style>
#signature {
  border: double 3px transparent;
  border-radius: 5px;
  background-image: linear-gradient(white, white),
  radial-gradient(circle at top left, #b1b1b1, #b1b1b1);
  background-origin: border-box;
  background-clip: content-box, border-box;
}
.active-item {
  background-color: #cccccc;
}
</style>
